import { getIn } from 'timm';
import { call, put, all, takeLatest } from 'redux-saga/effects';
import { showErrorNotification } from 'x/views/xtra/ui';
import { captureExceptionInSentry } from 'x/modules';
import { transformVendorPreferencesResponse } from './VendorPreferences/utils';
import VendorPortalDuck from './duck';

function* fetchTDSCategories() {
  const api = window.api;

  try {
    let resp = yield call(api.vendorPortal.fetchTDSCategories, {});
    resp = resp.data;

    if (!resp) {
      throw new Error('NO_VALUES');
    }

    const tdsCategories = getIn(resp, ['tds_categories']) || [];

    yield put(VendorPortalDuck.creators.fetchTDSCategoriesSuccess(tdsCategories));
  } catch (e) {
    captureExceptionInSentry(e);
    console.error(e);
    const errorText = 'Failed to fetch TDS Categories';

    yield put(showErrorNotification(errorText));
    yield put(VendorPortalDuck.creators.fetchTDSCategoriesFailure());
  }
}

function* fetchInvoicesCreationStatus(action) {
  const api = window.api;

  try {
    const merchantId = action.payload.merchantId;
    const resp = yield call(api.vendorPortal.getInvoices, merchantId, {
      count: 1,
    });

    if (resp.status_code !== 200) {
      // eslint-disable-next-line no-throw-literal
      throw { error: 'NO_VALUES' };
    }

    const data = resp?.data?.count;

    yield put(VendorPortalDuck.creators.fetchInvoicesCreationStatusSuccess(data));
  } catch (e) {
    captureExceptionInSentry(e);
    console.error(e);
    const errorText = 'Failed to fetch invoice count';

    yield put(showErrorNotification(errorText));
    yield put(VendorPortalDuck.creators.fetchInvoicesCreationStatusFailure());
  }
}

function* fetchVendorPreferences(action) {
  const api = window.api;

  try {
    const merchantId = action.payload.merchantId;
    let resp = yield call(api.vendorPortal.getVendorPreferences, merchantId);
    resp = resp.data;

    if (!resp) {
      throw new Error('NO_VALUES');
    }

    const vendorPreferences = transformVendorPreferencesResponse(resp);

    yield put(VendorPortalDuck.creators.fetchVendorPreferencesSuccess(vendorPreferences));
  } catch (e) {
    captureExceptionInSentry(e);
    console.error(e);
    const errorText = 'Failed to fetch vendor preferences';

    yield put(showErrorNotification(errorText));
    yield put(VendorPortalDuck.creators.fetchVendorPreferencesFailure());
  }
}

export default function* vendorPortalSaga() {
  yield all([
    takeLatest(VendorPortalDuck.types.FETCH_TDS_CATEGORIES, fetchTDSCategories),
    takeLatest(VendorPortalDuck.types.FETCH_INVOICE_CREATION_STATUS, fetchInvoicesCreationStatus),
    takeLatest(VendorPortalDuck.types.FETCH_VENDOR_PREFERENCES, fetchVendorPreferences),
  ]);
}
